import _ from 'lodash';

_.mixin({
    stringToBoolean: function(string) {
        const areTrue = ['yes', 'true', true, 'y', 1, '1'];

        if (_.isString(string)) { string = string.toLowerCase(); }
        if (_.indexOf(areTrue, string) > -1) { return true; }
        
        return false;
    }
});
